import * as React from "react";
import { IProduct } from "../models/IProduct.model";
import BasketService from "../services/BasketService";
import ErrorBoundary from "./ErrorBoundary";
import ProductCard from "./ProductCard";
import YouMayAlsoLikePlaceholder from "./YouMayAlsoLikePlaceholder";
import { IBasket } from "../models/IBasket.model";
import Logger from "../../../gulp/scripts/typescript/modules/logger";
import ScrollCarousel from "../../../gulp/scripts/typescript/modules/scroll-carousel";

function YouMayAlsoLike(props: IBasket) {
	const [isLoading, setIsLoading] = React.useState(false);
	const [products, setProducts] = React.useState<IProduct[]>([]);
	const carouselContainerRef = React.useRef<HTMLDivElement>(null);
	const scrollCarouselInstance = React.useRef<ScrollCarousel | null>(null);

	const basketService = new BasketService();

	React.useEffect(() => {
		getYouMayAlsoLikeProducts();
	}, [props]);

	React.useEffect(() => {

		if (carouselContainerRef.current && products.length > 0) {
			const delay = setTimeout(() => {
				scrollCarouselInstance.current = new ScrollCarousel(carouselContainerRef.current);
			}, 100);
			return () => clearTimeout(delay);
		}
	
	}, [products]);

	function getYouMayAlsoLikeProducts() {
		setIsLoading(true);
		basketService.getYouMayAlsoLikeProducts()
			.then((data) => {
				setIsLoading(false);
				setProducts(data.Products);
			})
			.catch((error) => {
				setIsLoading(false);
				Logger.trackException(error, 'Unknown error in get you may also like endpoint in basket');
			});
	}

	if (isLoading) {
		return <YouMayAlsoLikePlaceholder />;
	}

	return (
		<ErrorBoundary>
			<div className="c-basket__upsell">
				{products.length > 0 ? (
					<div className="c-basket__upsell-row" data-test="you-may-also-like-carousel">
						<h2 className="c-basket__upsell-title">You may also like</h2>
							<div ref={carouselContainerRef} className="c-carousel c-carousel--you-may-also-like js-scroll-carousel">
								<ul className="c-carousel__list">
									{products.map((product) => (
										<li className="c-carousel__item js-scroll-carousel-item" key={product.Name}>
											<ProductCard {...product} />
										</li>
									))}
								</ul>
							</div>
					</div>
				) : null}
			</div>
		</ErrorBoundary>
	);
}

export default YouMayAlsoLike;
